import React, { useState } from "react"
import { makeStyles } from "makeStyles"

import ItemsCarousel from "react-items-carousel"

import useWindowSize from "@secureo/common/hooks/useWindowSize"

import { BsArrowLeft, BsArrowRight } from "react-icons/bs"

import Image from "next/image"

import Apotheken from "/images/branchenloesungen/branchen-apotheken.jpg"
import Autohaeuser from "/images/branchenloesungen/branchen-autohaeuser.jpg"
import Filialen from "/images/branchenloesungen/branchen-filialen.jpg"
import Hotels from "/images/branchenloesungen/branchen-hotels.jpg"

const useStyles = makeStyles()(() => ({
	arrowButtonLeft: {
		position: "absolute",
		bottom: -50,
		left: 0, // fix that
		padding: 5,
		outline: "none",
		background: "none",
		border: "none",
		cursor: "pointer",
	},
	arrowButtonRight: {
		position: "absolute",
		bottom: -50,
		right: "100%",
		padding: 5,
		outline: "none",
		background: "none",
		border: "none",
		cursor: "pointer",
	},
	slide: {
		position: "relative",
		textAlign: "center",
		borderRadius: 5,
		height: 600,
	},
}))

const items = [
	{
		image: Apotheken,
		headline: "BTM-Tresore für Apotheken",
		link: "#btm",
	},
	{
		image: Autohaeuser,
		headline: "Schlüsselsafes für Autohäuser",
		link: "#schluesselsafes",
	},
	{
		image: Filialen,
		headline: "Einwurftresore für Filialisten",
		link: "#einwurftresore",
	},
	{
		image: Hotels,
		headline: "Hotelsafes für Unterkünfte",
		link: "#hotelsafes",
	},
]

const Slider = () => {
	const { classes } = useStyles()

	const [activeItemIndex, setActiveItemIndex] = useState(0)
	const chevronWidth = 0
	const { innerWidth } = useWindowSize()

	const isDesktop = innerWidth >= 1280

	const slideCount = isDesktop ? 3 : 1

	return (
		<div style={{ position: "relative" }}>
			<ItemsCarousel
				requestToChangeActive={setActiveItemIndex}
				activeItemIndex={activeItemIndex}
				numberOfCards={slideCount}
				gutter={10}
				leftChevron={
					<button className={classes.arrowButtonLeft}>
						<BsArrowLeft size="1.8rem" color="#fff" />
					</button>
				}
				rightChevron={
					<button className={classes.arrowButtonRight}>
						<BsArrowRight size="1.8rem" color="#fff" />
					</button>
				}
				chevronWidth={chevronWidth}
				infiniteLoop={true}
				slidesToScroll={slideCount}
				showSlither={false}
			>
				{items.map((item, i) => {
					const { image, headline, link } = item
					return (
						<a key={i} href={link} style={{ textDecoration: "none" }}>
							<div className={classes.slide}>
								<Image
									alt="image"
									title="image"
									src={image}
									quality={100}
									fill
									sizes="100vw"
									style={{
										objectFit: "cover",
									}}
								/>
								<div
									style={{
										position: "absolute",
										top: 220,
										left: -180,
										zIndex: 2,
										width: "100%",
										transform: "rotate(-90deg)",
									}}
								>
									<div
										style={{
											textAlign: "right",
											color: "#fff",
											textShadow: "1px 1px 2px black",
											fontSize: 22,
										}}
									>
										<strong>{headline}</strong>
									</div>
								</div>
							</div>
						</a>
					)
				})}
			</ItemsCarousel>
		</div>
	)
}
export default Slider
